import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: string = '';

export const bookmarkFilterSlice = createSlice({
  name: 'bookmarkFilter',
  initialState,
  reducers: {
    setFilterTerm: (state, action: PayloadAction<string>) => {
      return action.payload;
    },
    resetFilterTerm: () => {
      return '';
    }
  }
});

export const { setFilterTerm, resetFilterTerm } = bookmarkFilterSlice.actions;
export default bookmarkFilterSlice.reducer;
